import { render, staticRenderFns } from "./btn-tertiary.vue?vue&type=template&id=2baffd35&scoped=true&"
import script from "./btn-tertiary.vue?vue&type=script&lang=js&"
export * from "./btn-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baffd35",
  null
  
)

export default component.exports